import { render } from "./EmomWorkout.vue?vue&type=template&id=0c08f70f&scoped=true"
import script from "./EmomWorkout.vue?vue&type=script&lang=js"
export * from "./EmomWorkout.vue?vue&type=script&lang=js"

import "./EmomWorkout.vue?vue&type=style&index=0&id=0c08f70f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c08f70f"]])

export default __exports__